import { shallowEqual, useSelector } from 'react-redux';
import { ReduxState } from '../redux/reducers';

export const useShallowEqualSelector = <T extends ReduxState, S>(
  selector: (s: T) => S,
) => useSelector<T, S>(selector, shallowEqual);
